import { GameObj } from "../GameObj";
import { UnitType } from "./UnitType";
import type { UnitContext, PlaceContext, ObjContext, MakeContext } from "./context";

export class Imp extends UnitType {
    readonly id = "imp";
    readonly displayName = "Imp";
    playerCanDeploy(ctx: UnitContext) { return ctx.world === ctx.game.netherworld; }
    canEnter(ctx: PlaceContext) { return !ctx.world.hasNearbyObj(ctx.x, ctx.y, 4, "shrine") && this.inTile(ctx, ["land"]); }
    description() { return "Defeats peasants, fiends and other imps."; }
    cost() { return { blood: 100, souls: 2, runes: 0 }; }
    img(ctx: UnitContext) { return "imp_" + ctx.faction; }
    defeats() { return ["peasant", "fiend", "imp"]; }
    maxCooldown() { return 5000; }
    moveRange() { return 3.5; }
    make(ctx: MakeContext) { return new GameObj(ctx.faction, "imp"); }
    step(ctx: ObjContext) {
        if (ctx.faction !== "player") {
            this.hunt(ctx, c => {
                const obj = c.world.get(c.x, c.y);
                if (obj) {
                    if (this.canDefeat(obj.unitId)) return 3;
                    if (this.canHuntStaticObjectiveNear(ctx, c.x, c.y)) return 2;
                }
                return c.game.influenceMap.get(c.x, c.y) !== ctx.faction ? 1 : 0;
            });
        }
    }
    influenceRange(): number { return 2; }
}
